import axios from 'axios'

/**
 * API key to append to requests
 */
export const api_key = {
    api_key: 'giabamf',
}

/**
 * export default url for axios
 */
export default axios.create({
    baseURL: `https://api.eaglewebservices.com/v3`,
})
